'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class;

var _pacomo = require('utils/pacomo');

var _reduxUi = require('redux-ui');

var _reduxUi2 = _interopRequireDefault(_reduxUi);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    Flight424Modal: {
        displayName: 'Flight424Modal'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/Users/gareth.chou/Documents/GAdventures/g-rex/app/components/RequirementSet/Flight424Modal.js',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var Flight424Modal = _wrapComponent('Flight424Modal')((_dec = (0, _reduxUi2.default)(), _dec(_class = (0, _pacomo.pacomoDecorator)(_class = function (_Component) {
    (0, _inherits3.default)(Flight424Modal, _Component);

    function Flight424Modal(props) {
        (0, _classCallCheck3.default)(this, Flight424Modal);
        return (0, _possibleConstructorReturn3.default)(this, (Flight424Modal.__proto__ || (0, _getPrototypeOf2.default)(Flight424Modal)).call(this, props));
    }

    (0, _createClass3.default)(Flight424Modal, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                ui = _props.ui,
                updateUI = _props.updateUI;

            return _react3.default.createElement(
                'div',
                { className: 'reminder-modal ' + (ui.flight424Error ? 'is-visible' : 'is-hidden'),
                    tabIndex: '-1',
                    role: 'dialog' },
                _react3.default.createElement('div', { className: 'overlay' }),
                _react3.default.createElement(
                    'div',
                    { className: 'modal-dialog', role: 'document' },
                    _react3.default.createElement(
                        'div',
                        { className: 'modal-content' },
                        _react3.default.createElement(
                            'div',
                            { className: 'modal-header' },
                            _react3.default.createElement(
                                'button',
                                {
                                    className: 'close',
                                    type: 'button',
                                    onClick: function onClick() {
                                        updateUI("flight424Error", false);
                                    } },
                                _react3.default.createElement(
                                    'span',
                                    { 'aria-hidden': 'false' },
                                    '\xD7'
                                )
                            ),
                            _react3.default.createElement(
                                'h4',
                                { className: 'modal-title' },
                                _react3.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'Flight424Modal.title',
                                    defaultMessage: 'We need more information' })
                            )
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'modal-body' },
                            _react3.default.createElement(
                                'div',
                                { className: 'form-group' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'row' },
                                    _react3.default.createElement(
                                        'div',
                                        { className: 'col-12' },
                                        _react3.default.createElement(
                                            'div',
                                            { className: 'form-group reminder-text' },
                                            _react3.default.createElement(
                                                'p',
                                                null,
                                                _react3.default.createElement(_reactIntl.FormattedMessage, {
                                                    id: 'Flight424Modal.notice',
                                                    defaultMessage: 'We want to ensure the flights you\'ve entered are correct. Please review the information you\'ve provided, and enter your arrival airport along with the arriving date and time.' })
                                            ),
                                            _react3.default.createElement(
                                                'p',
                                                null,
                                                _react3.default.createElement(_reactIntl.FormattedMessage, {
                                                    id: 'Flight424Modal.notice_2',
                                                    defaultMessage: 'This will ensure we have the most accurate data in our system. If we need anything from you, we\'ll contact you to confirm.'
                                                })
                                            ),
                                            _react3.default.createElement(
                                                'p',
                                                null,
                                                _react3.default.createElement(_reactIntl.FormattedMessage, {
                                                    id: 'Flight424Modal.notice_3',
                                                    defaultMessage: 'Don\'t forget to click save!' })
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'modal-footer' },
                            _react3.default.createElement(
                                'button',
                                { className: 'button', onClick: function onClick(e) {
                                        e.preventDefault();
                                        updateUI("flight424Error", false);
                                    } },
                                'Continue'
                            )
                        )
                    )
                )
            );
        }
    }]);
    return Flight424Modal;
}(_react2.Component)) || _class) || _class));

exports.default = Flight424Modal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/RequirementSet/Flight424Modal.js
// module id = 1313
// module chunks = 0